<template>
  <div class="question-content">
      <h3>{{ question.text }}</h3>
      <div class="row image_row">
        <div v-for="(image, i) in orderedImages" :key="image.id" class="image col-xs-4">
          <div class="image__controls">
            <input @click="onImageClick(image)" ref="selected_image"
                  v-model="selectedValue" :value="image.id"
                  type="radio"
                  name="selected_image"
                  style="cursor: pointer">
          </div>

          <div class="image__content text-center" @click="onImageClick(image)">
            <div class="image__image"
                v-bind:style="{ backgroundImage: 'url(' + image.image.url + ')' }"></div>
            <p>{{ imageLabel(i)|capitalize }}</p>
          </div>
          
        </div>
      </div>
  </div>

</template>

<script>
import {mapActions} from 'vuex'

export default {
  props: {
    question: Object,
    survey: Object,
    category: String
  },
  data() {
    return {
      selectedValue: null
    }
  },
  watch: {
    question: {
      handler(val, oldVal) {
        if (this.question.answer) {
          this.selectedValue = this.question.answer
        } else if (this.question.last_answer) {
          this.selectedValue = this.question.last_answer
        }
      },
      immediate: true
    }
  },
  computed: {
    orderedImages() {
      const images = JSON.parse(JSON.stringify(this.question.images));
        images.sort((a, b) => {
          return a.order > b.order ? 1 : -1;
        })
        return images
    }
  },
  methods: {
    ...mapActions('take_survey', ['sendAnswer']),
    imageLabel(i) {
      const baseLabels = ['good', 'better', 'best']
      const baseLabel = baseLabels[i]
      if (this.question.metadata && this.question.metadata.costTagLabels) {
        return this.question.metadata.costTagLabels[baseLabel] || baseLabel
      }
      return baseLabel
    },
    onImageClick(image){
      if (image.id !== this.selectedValue) {
          this.selectedValue = image.id;

          const answerData = {'answer': image.id, 'comment': null}
          this.sendAnswer({'surveyId': this.question.survey.id, 'questionId': this.question.id, 'answerData': answerData}).then(
            () => {
              this.$emit('answer', image.id);
            }
          )
        } else {
          setTimeout(() =>{
            this.$emit('answer', image.id);
          }, 500)
        }
    }
  }
}

</script>

<style lang="scss" scoped>
.question-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  text-align: left;

  .question-thumbnail {
    margin-top: 20px;
    width: 100%;
    height: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

  }
}

.image_row {
  width: 100%;
  display: flex;
  justify-content: center;
}

.image {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        margin-right: 2px;
        margin-left: 2px;
        //padding: 10px;
        &:hover {
          border: 3px solid #e7e7e7;
        }
        //min-width: 270px;

        @media(max-width: 768px) {
          //min-width: 200px;
        }


        position: relative;
        //height: 400px;
        min-height: 200px;

        &__controls {
          position: absolute;
          right: 10px;
          top: 10px;

          a {
            color: inherit;
            padding-left: 10px;
          }

          input {
            transform: scale(1.5);
          }

          a:hover {
            color: #6bcafd;
          }
        }

        &__tags {
          position: absolute;
          left: 10px;
          bottom: 10px;
          font-weight: bold;

          a {
            color: inherit;
            padding-left: 10px;
          }

          input {
            transform: scale(1.5);
          }

          a:hover {
            color: #6bcafd;
          }
        }

        &__zoom {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-weight: bold;
          font-size: 1.5em;
          //z-index: 99999;

          a {
            color: inherit;
            padding-left: 10px;
          }

          input {
            transform: scale(1.5);
          }

          a:hover {
            color: #6bcafd;
          }
        }


        &:hover {
          -webkit-filter: brightness(103%);
          filter: brightness(103%);

        }

        &__title {
          display: block;
          flex: 0;
          width: 100%;
          border-bottom: 1px solid rgb(239, 239, 239);
          padding-bottom: 5px;
          font-weight: bold;
        }

        &__image {
          flex: 1;
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          //padding: 5px 0px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          height: 100%;
        }

        &__footer {
          width: 100%;
          font-size: 0.8em;
          background-color: rgba(253, 207, 0, 0.288);
          padding-left: 10px;
        }

        &__content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          //padding: 5px 0px;
        }

      }

</style>